// UI texts: collection book (6.5)
export default {
  title: 'Collection',
  sub: 'Every item in every rarity. A field opens the first time you own it. Complete a category, a set or a rarity for a title, a badge or a share card frame.',
  progress: '{n} of {total} found',
  tabs: { category: 'Weapons & packs', set: 'Sets', rarity: 'Rarities', named: 'Named', stories: 'Stories' },
  /** Package 4, part D: the named enemies' page. */
  named: { bounty: 'Bounty this week', unseen: 'Not beaten yet. It shows up now and then on a run in its zone.' },
  /** 11. 10. 2026 (owner, BACKLOG #33): the crew outfit (crew level 10). */
  crewOutfit: {
    owned: 'Yours since {season}, with the title {title}. On your survivor later.',
    locked: 'From a crew level {lv} chest, with the title {title}.',
  },
  /** 11. 10. 2026 (owner, docs/thepit.md): The Pit's season title. */
  pit: {
    title: 'Pit Champion',
    owned: 'Yours: you finished a season first in your league of the Pit.',
    locked: 'Finish a season first in your league of the Pit.',
    top10: 'You have the Pit frame and banner (a season in the top 10).',
  },
  /** Krug 5 (K4.16): the progress line on top. */
  progressByGroup: 'Progress by group',
  sets: 'Sets',
  unknown: 'Not found yet ({rarity})',
  perkHint: '{name} · {rarity}: tap for its perk',
  rewardTitle: 'Reward: title “{title}”',
  rewardBadge: 'Reward: profile badge',
  rewardFrame: 'Reward: share card frame',
  /** Outfits (docs/OUTFITI_garderoba.md, 4.3). */
  outfits: 'Outfits:',
  outfitDone: '{rarity} ✓',
  outfitProgress: '{rarity} {n}/5',
  outfitOpen: '{name}: open in Appearance',
  outfitThumb: '{name} outfit',
  outfitThumbLocked: '{name} outfit, locked ({n}/5)',
  uncCounts: 'Counts toward the Common outfit',
  /** 11. 10. 2026 (owner, BACKLOG #36): a set whose outfit pictures are not made yet (the Foundry). */
  outfitLater: 'Outfit coming later',
  columnDone: 'All five in {rarity}',
} as const;
